import { render, staticRenderFns } from "./record.vue?vue&type=template&id=2b1f7cae&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1f7cae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b1f7cae')) {
      api.createRecord('2b1f7cae', component.options)
    } else {
      api.reload('2b1f7cae', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=2b1f7cae&scoped=true", function () {
      api.rerender('2b1f7cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/platformCoupon/couponList/record.vue"
export default component.exports